import type { JobsListParams } from './jobs.api';

/**
 * Query keys for the ATS jobs list.
 *
 * A factory rather than inline arrays: two spellings of the same key are two
 * cache entries and two requests — the `fetchAiScoring` string-vs-number bug.
 * Mutations invalidate `lists()`, which replaces the RTK tag.
 */
export const jobsKeys = {
  all: ['ats-jobs'] as const,
  lists: () => [...jobsKeys.all, 'list'] as const,
  list: (params: JobsListParams) => [...jobsKeys.lists(), params] as const,
  detail: (jobId: string | number) =>
    [...jobsKeys.all, 'detail', String(jobId)] as const,
  stages: (jobId: string | number) =>
    [...jobsKeys.all, 'stages', String(jobId)] as const,
};
